import { render, staticRenderFns } from "./evaluation-details.vue?vue&type=template&id=2951f71a&"
import script from "./evaluation-details.vue?vue&type=script&lang=js&"
export * from "./evaluation-details.vue?vue&type=script&lang=js&"
import style0 from "./evaluation-details.vue?vue&type=style&index=0&id=2951f71a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports